import { Typography } from "~/common/components";

interface ShowAllergiesProps {
  allergies?: string;
}

export const Allergies = ({ allergies }: ShowAllergiesProps) => (
  <Typography>
    <span className="font-medium">Allergies: </span>
    {allergies ?? "None reported"}
  </Typography>
);
